import React from 'react';
import { useIntl } from 'react-intl';

import Wizard from 'Common/Components/Wizard';
import InfoBox from 'Common/Components/InfoBox';

import CheckAccountInformation from 'Common/containers/CheckAccountInformation';
import CheckStoreInformation from 'Common/containers/CheckStoreInformation';

import DatevLogin from '../Login';
import ConnectedPage from './ConnectedPage';

const WizardAssistant: React.FC<{ activeStep?: number }> = ({ activeStep }) => {
  const intl = useIntl();
  return (
    <Wizard
      activeStep={activeStep}
      steps={[
        {
          title: intl.formatMessage({ defaultMessage: 'Billing Address' }),
          content: (
            <CheckAccountInformation>
              <InfoBox
                text={intl.formatMessage({
                  defaultMessage:
                    'Please make sure that your company information is complete',
                })}
              />
            </CheckAccountInformation>
          ),
        },
        {
          title: intl.formatMessage({ defaultMessage: 'Store Address' }),
          content: (
            <CheckStoreInformation>
              <InfoBox
                text={intl.formatMessage({
                  defaultMessage:
                    'Please make sure your store information is complete. Your company and store addresses can be the same.',
                })}
              />
            </CheckStoreInformation>
          ),
        },
        {
          title: intl.formatMessage({ defaultMessage: 'Login To DATEV' }),
          content: <DatevLogin />,
        },
        {
          title: intl.formatMessage({ defaultMessage: 'All set' }),
          content: <ConnectedPage />,
        },
      ]}
    />
  );
};

export default WizardAssistant;
